export const LIMIT = 36;

export const FILTER_TYPE = {
    default: 'DEFAULT',
    range: 'RANGE',
};

export const FILTER_BREAKPOINT = 'md';

export const FILTER_ANIMATION_SECONDS = 0.2;

export const FALLBACK_SORT = 'Timestamp DESC';

export const CONTENT_PREFERENCE_CRITERIA = {
    cmsFirst: 'CMS_FIRST',
    cmsOnly: 'CMS_ONLY',
    playOnly: 'PLAY_ONLY',
    mixed: 'MIXED',
};

export const QUERY_TYPE = {
    freetext: 'FREETEXT',
    structured: 'STRUCTURED',
};

export const FILTER_LAYOUT = {
    tabs: 'TABS',
    list: 'LIST',
};